import { UPDATE_VORLAGE_STATION } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useUpdateVorlageStation/mutation';
import {
  Mitarbeiter_UpdateVorlageStationMutation,
  Mitarbeiter_UpdateVorlageStationMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useUpdateVorlageStation() {
  const [execute, result] = useMutation<
    Mitarbeiter_UpdateVorlageStationMutation,
    Mitarbeiter_UpdateVorlageStationMutationVariables
  >(UPDATE_VORLAGE_STATION, {
    refetchQueries: [
      'mitarbeiter_rotationsplanVorlagen',
      'mitarbeiter_rotationsplanVorlageById',
    ],
    awaitRefetchQueries: true,
  });

  const updateVorlageStation = useCallback(
    (variables: Mitarbeiter_UpdateVorlageStationMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );

  return [updateVorlageStation, result] as const;
}
